import Command from '@ckeditor/ckeditor5-core/src/command';
import { CkeditorConstants } from '../../src/utils';


const { helperAttributes: { DATA_IGNORE, DATA_HIDEROWS, DATA_SHOWROWS, NO_ONE, SUBTEMPLATES_ALLOW },
style: { block, none }} = CkeditorConstants;
export default class HideDataIgnoreAttributeCommand extends Command {
  constructor(editor) {
    super(editor);
  }

  execute({ value }) {
    const editor = this.editor;
    const range = editor.model.createRangeIn(editor.model.document.getRoot());
    const editingRootDomElement = editor.editing.view.domRoots.get('main');
    const dataIgnoreEle = [];
    for (const item of range.getItems({ ignoreElementEnd: true })) {
      if (
        item.getAttribute(DATA_IGNORE) === 'TRUE' &&
        item._children &&
        item._children.length <= 1 &&
        !item.getAncestors().reverse().find(ele => ele?.getAttribute(DATA_IGNORE) === 'TRUE')
      ) {
        dataIgnoreEle.push(item);
      }
    }

    editor.model.enqueueChange({ isUndoable: false }, (writer) => {
      editingRootDomElement
        .querySelectorAll(`[${DATA_IGNORE}="TRUE"]`)
        .forEach((element) => {
          for (let i = 0; i < element.childNodes.length; i = i + 2) {
            if (element.childNodes[i].getAttribute(NO_ONE) && !element.childNodes[i].hasAttribute(SUBTEMPLATES_ALLOW)) {
              element.childNodes[i].style.display = value ? block : none;
            }
          }
        });
      for (let i = 0; i < dataIgnoreEle.length; i++) {
        if (value) {
          if (dataIgnoreEle[i]._attrs.has(DATA_HIDEROWS)) {
            writer.removeAttribute(DATA_HIDEROWS, dataIgnoreEle[i]);
          }
          writer.setAttribute(DATA_SHOWROWS, ' ', dataIgnoreEle[i]);
        } else {
          if (dataIgnoreEle[i]._attrs.has(DATA_SHOWROWS)) {
            writer.removeAttribute(DATA_SHOWROWS, dataIgnoreEle[i]);
          }
          writer.setAttribute(DATA_HIDEROWS, ' ', dataIgnoreEle[i]);
        }
      }
    });
  }
}